/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type DepopStringPutObject = {
  value?: string | null;
};
export type editDepopItemMutationVariables = {
  itemId: string;
  size?: DepopStringPutObject | null;
};
export type editDepopItemMutationResponse = {
  readonly depopEditDepopItem: {
    readonly success: boolean;
  } | null;
};
export type editDepopItemMutation = {
  readonly response: editDepopItemMutationResponse;
  readonly variables: editDepopItemMutationVariables;
};

/*
mutation editDepopItemMutation(
  $itemId: String!
  $size: DepopStringPutObject
) {
  depopEditDepopItem(itemId: $itemId, size: $size) {
    success
  }
}
*/

const node: ConcreteRequest = (function () {
  var v0 = [
      {
        defaultValue: null,
        kind: 'LocalArgument',
        name: 'itemId',
      },
      {
        defaultValue: null,
        kind: 'LocalArgument',
        name: 'size',
      },
    ],
    v1 = [
      {
        alias: null,
        args: [
          {
            kind: 'Variable',
            name: 'itemId',
            variableName: 'itemId',
          },
          {
            kind: 'Variable',
            name: 'size',
            variableName: 'size',
          },
        ],
        concreteType: 'DepopEditDepopItemResponse',
        kind: 'LinkedField',
        name: 'depopEditDepopItem',
        plural: false,
        selections: [
          {
            alias: null,
            args: null,
            kind: 'ScalarField',
            name: 'success',
            storageKey: null,
          },
        ],
        storageKey: null,
      },
    ];
  return {
    fragment: {
      argumentDefinitions: v0 /*: any*/,
      kind: 'Fragment',
      metadata: null,
      name: 'editDepopItemMutation',
      selections: v1 /*: any*/,
      type: 'Mutation',
      abstractKey: null,
    },
    kind: 'Request',
    operation: {
      argumentDefinitions: v0 /*: any*/,
      kind: 'Operation',
      name: 'editDepopItemMutation',
      selections: v1 /*: any*/,
    },
    params: {
      cacheID: '679ab19629949209049f1754101893fb',
      id: null,
      metadata: {},
      name: 'editDepopItemMutation',
      operationKind: 'mutation',
      text: 'mutation editDepopItemMutation(\n  $itemId: String!\n  $size: DepopStringPutObject\n) {\n  depopEditDepopItem(itemId: $itemId, size: $size) {\n    success\n  }\n}\n',
    },
  };
})();
(node as any).hash = 'ca4ffc453a44ef7dbb75c5367b876e14';
export default node;
